export default {
  data () {
    return {};
  },
  methods: {
    // 获取列表数据
    searchTableInfo () {
      this.filter.pageIndex = 1;
      this.getTableInfo({ filter: this.filter });
    },
    // 重置方法
    resetTableInfo (initFilter) {
      this.filter = {
        pageIndex: 1,
        pageSize: 10,
        ...initFilter
      };
      console.log('filter', this.filter);
      this.getTableInfo({ filter: this.filter });
    },
    // 翻页
    changePage (num) {
      this.filter.pageIndex = num;
      this.getTableInfo({ filter: this.filter });
    },
    // 切换每页条数
    pageSizeChange (size) {
      this.filter.pageSize = size;
      this.searchTableInfo();
    }
  },
  mounted () {
    this.searchTableInfo();
  }
};
